import type { PlayerStatsDto } from '@/api/dto';
import type { Letters } from '@/domain/scoring';
import { HiWord } from '@/components/round/HiWord';
import { Card } from '@/components/ui/Card';
import { ru } from '@/i18n/ru';
import styles from './StatsCard.module.css';

interface StatsCardProps {
  stats: PlayerStatsDto;
  letters?: Letters;
}

export function StatsCard({ stats, letters }: StatsCardProps) {
  return (
    <Card className={styles.card}>
      <div className={styles.stats}>
        <div className={styles.stat}>
          <span className={`${styles.value} ${styles.l1}`}>{stats.games}</span>
          <span className={styles.label}>{ru.stats.games}</span>
        </div>
        <div className={styles.stat}>
          <span className={`${styles.value} ${styles.l2}`}>{stats.winrate}%</span>
          <span className={styles.label}>{ru.stats.winrate}</span>
        </div>
        <div className={styles.stat}>
          <span className={`${styles.value} ${styles.l3}`}>{stats.avgScore}</span>
          <span className={styles.label}>{ru.stats.avgScore}</span>
        </div>
      </div>
      {stats.best && (
        <>
          <div className={styles.divider} />
          <div className={styles.bestRow}>
            <span className={styles.bestLabel}>{ru.stats.bestWord}</span>
            <span className={styles.bestValue}>
              <HiWord word={stats.best.word} letters={letters} size="md" />
              <span className={styles.bestScore}>· {stats.best.score}</span>
            </span>
          </div>
        </>
      )}
    </Card>
  );
}
